import React from 'react';
import PropTypes from 'prop-types';

import './Tooltip.scss';

/**
 * Tooltip that pops out on hover
 */

const TooltipComponent = (props) => {
  const { label, position, theme, isActive } = props;

  const positionClass = position ? `tooltip-component--${position}` : '';
  const activeClass = isActive ? 'tooltip-component--active' : '';

  return (
    <div
      className={`tooltip-component tooltip-component--${theme} u-fontFamily-primaryMedium ${positionClass} ${activeClass}`}
    >
      <div className="tooltip-component__arrow arrow" />
      {label}
    </div>
  );
};

TooltipComponent.displayName = 'Tooltip';

TooltipComponent.propTypes = {
  label: PropTypes.string.isRequired,
  theme: PropTypes.oneOf(['tile', 'standalone']),
  position: PropTypes.string,
  isActive: PropTypes.bool,
};
TooltipComponent.defaultProps = {
  theme: 'tile',
  position: 'top',
  isActive: false,
};

export default TooltipComponent;
